import styled from 'styled-components';
import { SearchLabel } from './SearchLabel';

export const ToggleLabel = SearchLabel.extend`
  display: inline-block;
  width: 70%;
  word-break: break-word;
`;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/styles/ToggleLabel.js